
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/rooms/[id]",
      function () {
        return require("private-next-pages/shop/rooms/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/rooms/[id]"])
      });
    }
  